module.exports = __webpack_public_path__ + "img/check_8.d800639f.png";